export const ROUTES = {
  BUSINESS: '/business',
  BUSINESS_CREATE: '/business/create',
  BUSINESS_UPDATE: '/business/:id/update',
  REDEEM_INVITATION_REGISTER: '/redeem-invitation/business/register',
} as const;
